<div class="btn-group mood text-center">
    <div *ngFor="let mood of moods, let i=index">
        <div class="mood-rd">
            <img (click)="scoreChange(i+1)" [src]="'/assets/img/intern/icons/menus/'+mood+'.svg'" [alt]="mood" [class]="'icon bg-'+mood" [class.active]="score===(i+1) || scoreArr.indexOf(i+1)>=0">
        </div>
        <p *ngIf="buttons" class="o-5 m-0 lh-1"><small>{{ buttons[i] }}</small></p>
    </div>
</div>